module.exports = __webpack_public_path__ + "img/check.37b6bc65.png";